var Features = require("lib/account/Features");
var AccountPlans = require("lib/account/AccountPlans");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");

import { Link } from "react-router-dom";
import moment from 'moment';

require("users/teachers/upgrade/trial_status_display.scss");

class TrialStatusDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { expanded: false };
	}

	renderTrialBox(trialKey, endDate) {
		var daysLeft = Math.ceil((moment(endDate, "YYYY-MM-DD") - moment()) / MS_PER_DAY);
		var daysWord = $wr.pluralize("day", daysLeft);
		
		if (daysLeft <=-1) {
			var expired = true;
			var daysLeftDisplay = (
				<strong>This trial has ended</strong>
			)
		} else {
			var expired = false;
			var daysLeftDisplay = (
				<strong>{ daysLeft } { daysWord } left{" "}</strong>
			)
		}

		if (this.isProductTrial(trialKey)) {
			var pricingLink = WhooosReadingServices.OuterPages.url("/pricing");

			if (trialKey == AccountPlans.PRODUCTS.WR_SILVER) {
				var trialBenefits = " like writing data, student differentiation, and reading logs.";
			} else {
				var trialBenefits = ".";
			}

			if (expired) {
				var lowerLeftContent = (
					<p>
						<Link to={ this.getUpgradePath(trialKey) }>
							Upgrade now 
						</Link> to get { this.getTrialName(trialKey) }.
					</p>
				);

				var rightContent = (
					<p>
						<a href={ this.getCalendlyURL(trialKey) } target="_blank">
							Schedule a consultation
						</a> to learn more about {" "}
						<em>{ this.getTrialName(trialKey) }</em>.
					</p>
				);


			} else {
				var lowerLeftContent = (
					<span>
						<a href={ pricingLink } target="_blank">
							Learn more about Whooo's Reading plans
						</a>.
					</span>
				);
				var rightContent = (
					<p>
						<Link to={ this.getUpgradePath(trialKey) }>
							Upgrade now to keep { this.getTrialName(trialKey) } features
						</Link>{ trialBenefits }
					</p>
				);
			}


		} else {
			if (!expired) {
				var lowerLeftContent = (
					<span>
						<a href={ this.getLeftURL(trialKey) } target="_blank">
							Learn how to use this feature
						</a>.
					</span>
				);
			}
			var rightContent = (
				<p>
					<a href={ this.getCalendlyURL(trialKey) } target="_blank">
						Schedule a consultation
					</a> to learn about how to keep{" "}
					<em>{ this.getTrialName(trialKey) }</em>{" "}
					and other premium <em>Whooo's Reading</em> features.
				</p>
			);
		}

		return (
			<div className="trialBox hideOnPrint" key={ trialKey }>
				<div className="imageBox">
					<img src={ require("misc/alarm-clock.png") } />
				</div>
				<div className="statusBox">
					<p>
						<em>{ this.getTrialName(trialKey) } Trial </em>:{" "}
						{ daysLeftDisplay } <br />
						{ lowerLeftContent }
					</p>
				</div>
				<div className="divider" />
				<div className="consultationBox">
					{ rightContent }
				</div>
			</div>
		);
	}

	onExpand(e) {
		$wr.nope(e)
		this.setState({ expanded: true });
	}

	render() {
		var sortedPairs = _.select(_.sortBy(_.pairs(this.props.trials), _.last), (pair) => {
			var endDate = pair[1];
			var daysLeft = Math.ceil((moment(endDate, "YYYY-MM-DD") - moment()) / MS_PER_DAY);
		
			if (daysLeft >= -14) {
				return this.isTrialFeature(pair[0])	
			}
		});

		if ((sortedPairs.length > 1) && !this.state.expanded) {
			var expandLink = (
				<div className="expandLinkLine">
					<a href="#" onClick={ this.onExpand }>
						+ { sortedPairs.length - 1 } more (expand)
					</a>
				</div>
			)
			sortedPairs = [sortedPairs[0]];
		}

		var trialBoxes = _.map(sortedPairs, (pair) => {
			var endDate = pair[1];
			var daysLeft = Math.ceil((moment(endDate, "YYYY-MM-DD") - moment()) / MS_PER_DAY);
		
			if (daysLeft >= -14) {
				return this.renderTrialBox(pair[0], pair[1]);
			} else {
				console.log("Nope")
				return
			}
		});

		return (
			<div className="trialStatusDisplay">
				{ trialBoxes }
				{ expandLink }
			</div>
		);
	}

	isProductTrial(key) {
		return key == AccountPlans.PRODUCTS.WR_SILVER || key == AccountPlans.PRODUCTS.WR_GOLD;
	}

	getTrialName(key) {
		switch(key) {
		case Features.DIGITAL_EXERCISES:
			return "Insights and Exercises";
		case Features.LOG_READING:
			return "Log Reading";
		case Features.TEACHER_COMMENTS:
			return "Quiz Details and Comments";
		case Features.CLOZE_ASSESSMENTS:
			return "Reading Level Diagnostics";
		case AccountPlans.PRODUCTS.WR_SILVER:
			return "WR Silver";
		case AccountPlans.PRODUCTS.WR_GOLD:
			return "WR Gold";
		}
	}

	isTrialFeature(key) {
		return _.includes([
			Features.DIGITAL_EXERCISES, Features.LOG_READING, Features.TEACHER_COMMENTS,
			Features.CLOZE_ASSESSMENTS, AccountPlans.PRODUCTS.WR_SILVER, AccountPlans.PRODUCTS.WR_GOLD
		], key);
	}

	getLeftURL(key) {
		switch(key) {
		case Features.DIGITAL_EXERCISES:
			return "https://whooosreading.zendesk.com/hc/en-us/articles/115001793392-Exercises";
		case Features.LOG_READING:
			return "https://whooosreading.zendesk.com/hc/en-us/articles/115001537272-Logging-Reading";
		case Features.AUTOGRADER_DATA, Features.TEACHER_COMMENTS:
			return "https://whooosreading.zendesk.com/hc/en-us/articles/115001803091-Teacher-Commenting";
		case Features.CLOZE_ASSESSMENTS:
			return "https://docs.google.com/document/d/1hLPN9Q6MVQhv84DOxXVQgoLjvIOSbrMucwWdumc08WA";
		case AccountPlans.PRODUCTS.WR_SILVER:
		case AccountPlans.PRODUCTS.WR_GOLD:
			return "https://www.whooosreading.org/pricing";
		}
	}

	getCalendlyURL(key) {
		switch(key) {
		case Features.CLOZE_ASSESSMENTS:
			return "https://calendly.com/whooos-reading/reading-level-diagnostics";
		default:
			return "https://calendly.com/whooos-reading/wrs-consultation"
		}
	}

	getUpgradePath(key) {
		switch(key) {
		case AccountPlans.PRODUCTS.WR_SILVER:
			return "/upgrade?plan=silver";
		case AccountPlans.PRODUCTS.WR_GOLD:
			return "/upgrade?plan=gold";
		}
	}

}

var MS_PER_DAY = 60 * 60 * 24 * 1000;

TrialStatusDisplay.propTypes = StrictPropTypes({
	trials: PropTypes.object.isRequired
});


module.exports = TrialStatusDisplay;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/upgrade/TrialStatusDisplay.js